/**
 * Where the general-notification service (in-app broadcasts) lives, or null.
 *
 * `localhost` is a LOCAL-DEVELOPMENT default only. Before 2026-09 every build
 * without VUE_APP_GENERAL_NOTIF_URL fell back to http://localhost:8000 — and
 * store builds from Appflow never had it set, so on members' phones the app
 * called localhost on every feed load (~4.8k failed calls a week in RUM) and
 * no broadcast ever arrived. Unconfigured now means "no general service":
 * callers skip the request instead of sending it nowhere.
 *
 * @param {Record<string, string | undefined>} env usually process.env
 * @returns {string | null} base URL without a trailing /api, or null
 */
export function resolveGeneralNotifBase(env) {
  const configured = env.VUE_APP_GENERAL_NOTIF_URL;
  if (configured) return configured.replace(/\/api\/?$/, '');
  return env.VUE_APP_NODE_ENV === 'local' ? 'http://localhost:8000' : null;
}
